/* unplugin-vue-components disabled */import script from "./GeoStage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeoStage.vue?vue&type=script&lang=ts&setup=true"

import "./GeoStage.vue?vue&type=style&index=0&id=22290cc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22290cc6"]])

export default __exports__